define('constants/integrationsConstants',[], function() {
    return {
        clio: 0,
        practicePanther: 1,
        hubSpot: 2,
        jobber: 3,
        zapier: 4,
        clioGrow: 5,
        lawmatics: 6,
        smokeball: 7,
        myCase: 8
    };
});
